import * as React from "react";

import { Hint, Suit } from "../common";
import { Card, Size } from "./Card";

export class Deck extends React.Component<{}, {}> {
  render() {
    const cards = [];

    cards.push(
      <Card
        number={1}
        suit={Suit.Yellow}
        size={Size.Large}
        hint={Hint.Highest}
      />
    );
    cards.push(
      <Card number={7} suit={Suit.Green} size={Size.Large} hint={Hint.Lowest} />
    );
    cards.push(
      <Card number={5} suit={Suit.Blue} size={Size.Large} hint={Hint.Only} />
    );
    cards.push(<div style={{ clear: "both" }} />);

    for (const size of [Size.Small, Size.Large]) {
      for (const suit of [Suit.Blue, Suit.Yellow, Suit.Pink, Suit.Green]) {
        for (let number = 1; number <= 9; ++number) {
          cards.push(<Card number={number} suit={suit} size={size} />);
        }
        cards.push(<div style={{ clear: "both" }} />);
      }
    }
    for (let number = 1; number <= 4; ++number) {
      cards.push(
        <Card number={number} suit={Suit.Rockets} size={Size.Large} />
      );
    }
    return <div>{cards}</div>;
  }
}
